const componentHelpers = {
  install (Vue) {
    Vue.prototype.$helpers = {
      modal (options = {}) {
        return Vue.modal(options);
      },
    };
  }
};

export default componentHelpers;
